<template>
  <vbt-dialog
    v-model="dialog"
    :title="title"
    width="400px"
    hide-submit-btn
  >
    <v-layout justify-center>
      <img id="barcodePic" />
    </v-layout>
  </vbt-dialog>
</template>

<script>
import JSBarcode from 'jsbarcode';

import { useDialog } from '@mixins/factories';

const renderJSBarcode = (barcode) => JSBarcode('#barcodePic', barcode).render();

export default {
  name: 'UmsUserBarcodeViewer',
  props: {
    barcode: {
      type: String,
      default: '',
    },
  },
  mixins: [
    useDialog(),
  ],
  computed: {
    title() {
      return `Barcode ${this.barcode}`;
    },
  },
  methods: {
    onDialogOpen() {
      this.$nextTick(() => renderJSBarcode(this.barcode));
    },
  },
};
</script>
